import { useEffect, useState } from 'react';
import { useAuth, useScope } from '../lib/hooks';
import { groupsApi, type GroupSummary } from '../lib/domain';
import { defaultScopeForUser } from '../lib/scopeStore';

// ARC-001/ARC-002: jede Aktion arbeitet auf genau einem Besitzbereich
// (privat oder eine Gruppe). Diese Auswahl steuert alle datenbezogenen
// Ansichten (Produkte, Listen, Kategorien, ...).
export function ScopeSwitcher() {
  const { user } = useAuth();
  const [scope, setScope] = useScope();
  const [groups, setGroups] = useState<GroupSummary[]>([]);

  useEffect(() => {
    if (user && !scope) setScope(defaultScopeForUser(user.id));
  }, [user, scope, setScope]);

  useEffect(() => {
    groupsApi
      .list()
      .then((res) => setGroups(res.groups))
      .catch(() => undefined);
  }, []);

  if (!user) return null;

  return (
    <div className="field">
      <label htmlFor="scope-switcher">Besitzbereich</label>
      <select id="scope-switcher" value={scope} onChange={(e) => setScope(e.target.value)}>
        <option value={defaultScopeForUser(user.id)}>Privat</option>
        {groups.map((g) => (
          <option key={g.id} value={`group:${g.id}`}>
            Gruppe: {g.name}
          </option>
        ))}
      </select>
    </div>
  );
}
